/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnSupportHK.css";
import { Link } from "react-router-dom";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnSupportHK extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnSupportHK-view">
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        <div className="EnSupportHK-section">
          <Link to="/En">
            <div className="EnSupportHK-back">
              <div className="EnSupportHK-backBtn"></div>
              <div className="EnSupportHK-backText">Back</div>
            </div>
          </Link>
          <div className="EnSupportHK-logo" />
          <div className="EnSupportHK-title">
            Stay United
            <br />
            Be with Hong Kong
          </div>

          <div className="EnSupportHK-outerContainer">
            <div className="EnSupportHK-container">
              <a
                href="https://peacemaker.check.plus/MissionDetails?no=55"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="EnSupportHK-description">
                  Emergency Fund Anti-COVID-19 for Grassroots
                </div>
                <div className="EnSupportHK-QR1" />
              </a>
            </div>

            <div className="EnSupportHK-container2">
              <a
                href="https://sunrisechurch.check.plus/MissionDetails?no=90"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="EnSupportHK-description">
                  Epidemic Prevention Fund
                </div>
                <div className="EnSupportHK-QR2" />
              </a>
            </div>

            <div className="EnSupportHK-container">
              <a
                href="https://lovefoundation.check.plus/MissionDetails?no=89"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="EnSupportHK-description">
                  Walk With Love Against Coronavirus
                </div>
                <div className="EnSupportHK-QR3" />
              </a>
            </div>
          </div>
        </div>

        <div className="EnSupportHK-footer">
          <div className="EnSupportHK-footerNav">
            <Link to="/EnTeam">
              <div className="EnSupportHK-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnSupportHK-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnSupportHK-footerNavItem">Contact Us</div>
            </Link>
          </div>

          <div className="EnSupportHK-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnSupportHK;
